import axios from 'axios';

import type {
  CreateAccountOkResponse,
  CreateAccountRequest,
} from './ErplySignupApi.types';

const url = 'https://signup-api.erply.com/';

export default class ErplySignupApi {
  static async createAccount(
    params: CreateAccountRequest,
  ): Promise<CreateAccountOkResponse> {
    const apiUrl = `${url}v1/account/create`;
    const { data } = await axios.post<CreateAccountOkResponse>(apiUrl, params);
    return data;
  }
}
